function paintCalculator() {
  if (!document.querySelector('.paint-calculator-container')) {
    return;
  }

  const wallTableBody = document.querySelector('.calculate-paint .walls tbody');
  const defaultWallRow = document.querySelector('.calculate-paint .walls tr:first-of-type')?.cloneNode(true);
  const nonCoveredTableBody = document.querySelector('.calculate-paint .non-covered tbody');
  const defaultNonCoveredRow = document
    .querySelector('.calculate-paint .non-covered tr:first-of-type')
    ?.cloneNode(true);
  const addToBasket = document.querySelector('.product-add-group-to-cart');
  const totalCost = document.querySelector('.variant-total-cost.price-incl > span');
  const formData = {
    items: [],
    sections: ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble', 'cart-drawer']
  };
  let paintRequired = 0;
  let counts = 0;
  let paints = 0;
  let options = [];
  let availablePaints = [];

  updatePaints();
  document.getElementById('calculate-paint').addEventListener('click', (event) => {
    updatePaints();

    const wallArea = calculateArea('walls');
    const nonCoveredArea = calculateArea('non-covered');
    const paintCoverage = Number(paints[0].paintCoverage);
    paintRequired = ((wallArea - nonCoveredArea) * Number(paints[0].numberOfCoats)) / paintCoverage;
    if (document.querySelector('.calculate-paint .wastage input').checked) {
      paintRequired = paintRequired * 1.1;
    }
    paintRequired = Math.ceil(paintRequired);

    document.querySelector('.calculate-paint .paint-count').innerText = paintRequired + ' Litres Required';

    counts = findCheapestCombination(paintRequired);

    document.querySelector('.calculate-paint .paint-price.price-incl').innerText = Shopify.formatMoney(
      calculateSubTotal(true)
    );
    document.querySelector('.calculate-paint .paint-price.price-excl').innerText = Shopify.formatMoney(
      Math.ceil(calculateSubTotal(true) / Number(window.taxPercent))
    );
    document.querySelector('.paint-calculator-container .area-covered').innerHTML = window.selectionCover
      .replace('{{ area }}', `<span>${wallArea - nonCoveredArea}m<sup>2</sup></span>`)
      .replace('{{ number }}', numberToWords(Number(event.target.dataset.numberOfCoats)));
  });

  document.querySelectorAll('variant-selects input[type="radio"]').forEach((radio) => {});

  document.querySelector('.calculate-paint .walls__add-row').addEventListener('click', () => {
    addRow(wallTableBody, defaultWallRow, 'walls');
  });

  document.querySelector('.calculate-paint .non-covered__add-row').addEventListener('click', () => {
    addRow(nonCoveredTableBody, defaultNonCoveredRow, '');
  });

  document.querySelector('.calculate-paint .product-add-tins.button').addEventListener('click', () => {
    updateQuantity();
    document.querySelectorAll('.drawer-container.open').forEach((drawerContainer) => closeDrawer(drawerContainer));
  });

  document.querySelectorAll('.paint-calculator-container .quantity__input').forEach((quantity) => {
    quantity.addEventListener('change', (event) => {
      if (
        event.target.closest('.accordion-content') &&
        event.target.closest('.accordion-content').querySelector('.next-step')
      ) {
        event.target.closest('.accordion-content').querySelector('.next-step').removeAttribute('disabled');
      } else {
        addToBasket.removeAttribute('disabled');
      }
      updateAddToBasketState();
      updateTotalCost(calculateSubTotal(false), true);
    });
  });

  function updateAddToBasketState() {
    let enableCta = false;
    document.querySelectorAll('.paint-calculator-container .variant-info .quantity__input').forEach((quantity) => {
      const colourInput = document.querySelector('.color-palette-container .colour-input');
      const drawerButton = document.querySelector('.color-palette-container .drawer-button');

      if (quantity.value > 0) {
        if ((drawerButton && drawerButton.classList.contains('active')) || (colourInput && colourInput.value !== '')) {
          enableCta = true;
        } else if (!drawerButton && !colourInput) {
          enableCta = true;
        }
      }

      if (enableCta) {
        addToBasket.removeAttribute('disabled');
      } else {
        addToBasket.setAttribute('disabled', 'disabled');
      }
      // Update other UI elements or calculations
      updateTotalCost(calculateSubTotal(false), true);
    });
  }

  document
    .querySelector('.color-palette-container .colour-input')
    ?.addEventListener('input', () => updateAddToBasketState());
  if (document.querySelector('.color-palette-container .drawer-button')) {
    const observer = new MutationObserver(() => updateAddToBasketState());
    observer.observe(document.querySelector('.color-palette-container .drawer-button'), {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  document.querySelector('variant-selects').addEventListener('change', updatePaints);

  document.querySelectorAll('.bundle-options .bundle-option').forEach((option) => {
    option.addEventListener('click', (event) => {
      if (option.classList.contains('checked')) {
        updateTotalCost(Number(totalCost.dataset.totalCost) + Number(option.dataset.price), false);
      } else {
        updateTotalCost(Number(totalCost.dataset.totalCost) - Number(option.dataset.price), false);
      }
    });
  });

  refreshListeners();

  addToBasket.addEventListener('click', (event) => {
    event.target.classList.add('loading');
    event.target.querySelector('.loading__spinner').classList.remove('hidden');

    addFormData();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => response.json())
      .then((response) => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          cartData: response
        });
        document.querySelector('cart-drawer').renderContents(response);
        formData.items = [];
      })
      .catch((error) => {
        showErrorBanner(event.target.parentNode, error);
      })
      .finally(() => {
        event.target.classList.remove('loading');
        event.target.querySelector('.loading__spinner').classList.add('hidden');
      });
  });

  function calculateArea(tableClass) {
    let wallArea = 0;
    document.querySelectorAll(`.calculate-paint .${tableClass} tr`).forEach((wall) => {
      wallArea =
        wallArea +
        Math.abs(wall.querySelector('input.width').value) * Math.abs(wall.querySelector('input.height').value);
    });
    return wallArea;
  }

  function addRow(tableBody, tableRow, wall) {
    tableBody.append(tableRow.cloneNode(true));
    reOrderWalls(tableBody, tableRow, wall);
  }

  function removeRow(tableBody, tableRow, wall) {
    tableBody.removeChild(tableRow);
    reOrderWalls(tableBody, tableRow, wall);
  }

  function reOrderWalls(tableBody, tableRow, wall) {
    tableBody.querySelectorAll('.wall-index').forEach((wallIndex, index) => {
      wallIndex.innerText = (wall === 'walls' ? 'Wall ' : 'Area ') + (index + 1);
    });
    refreshListeners();
  }

  function refreshListeners() {
    document.querySelectorAll('.calculate-paint tr svg').forEach((closeButton) => {
      closeButton.addEventListener('click', (event) => {
        if (event.target.closest('tbody').children.length > 1) {
          removeRow(
            event.target.closest('tbody'),
            event.target.closest('tr'),
            event.target.closest('table').parentNode.classList.value
          );
        }
        event.stopPropagation();
      });
    });
  }

  function Paint(
    volume,
    price,
    slug,
    productId,
    variantId,
    options,
    numberOfCoats,
    paintCoverage,
    inputSlug,
    available
  ) {
    this.volume = volume;
    this.price = price;
    this.slug = slug;
    this.productId = productId;
    this.variantId = variantId;
    this.options = options;
    this.numberOfCoats = numberOfCoats;
    this.paintCoverage = paintCoverage;
    this.inputSlug = inputSlug;
    this.available = available;
    this.pricePerLiter = price / volume; // Calculate price per liter
  }

  function comparePaint(paintA, paintB) {
    return paintA.pricePerLiter - paintB.pricePerLiter; // Sort by price per liter (ascending)
  }

  function findCheapestCombination(volumeNeeded) {
    const counts = availablePaints.map(() => 0); // Initialize an array with zeros for paint counts

    // Sort availablePaints by price per liter (ascending order)
    availablePaints.sort(comparePaint);

    for (let i = 0; i <= availablePaints.length; i++) {
      const litreNeeded = volumeNeeded / availablePaints[i].volume;
      const decimal = parseFloat((litreNeeded - Math.floor(litreNeeded)).toPrecision(1));
      let conditional = true;
      let paintFulfilledByNextPaint = false;
      if (availablePaints[i + 1]) {
        const nextPaintCost = Math.ceil(volumeNeeded / availablePaints[i + 1].volume) * availablePaints[i + 1].price;
        const paintCost = Math.ceil(litreNeeded) * availablePaints[i].price;
        conditional = paintCost < nextPaintCost && (decimal >= 0.8 || (!availablePaints[i + 2] && litreNeeded < 1));
        paintFulfilledByNextPaint =
          nextPaintCost < paintCost && (!availablePaints[i + 2] || i === availablePaints.length - 1);
        if (paintFulfilledByNextPaint) {
          const remainingVolume = volumeNeeded - Math.floor(litreNeeded) * availablePaints[i].volume;
          const combinationPaintCost =
            Math.floor(litreNeeded) * availablePaints[i].price +
            Math.ceil(remainingVolume / availablePaints[i + 1].volume) * availablePaints[i + 1].price;
          paintFulfilledByNextPaint = nextPaintCost < combinationPaintCost;
        }
      }
      if (!paintFulfilledByNextPaint) {
        counts[i] = conditional ? Math.ceil(litreNeeded) : Math.floor(litreNeeded);
      }
      volumeNeeded -= counts[i] * availablePaints[i].volume;
      if (volumeNeeded <= 0) {
        break;
      }
    }

    return counts;
  }

  function calculateSubTotal(calculating) {
    let subtotal = 0;
    for (let i = 0; i < availablePaints.length; i++) {
      const quantityInput = document.querySelector(
        `.paint-calculator-container .quantity__input.paint-${availablePaints[i].slug}`
      );
      if (counts[i] > 0 || Number(quantityInput.value) > 0) {
        subtotal += (!calculating ? Number(quantityInput.value) : counts[i]) * availablePaints[i].price;
      }
    }

    return subtotal;
  }

  function updateQuantity() {
    for (let i = 0; i < availablePaints.length; i++) {
      const quantityInput = document.querySelector(
        `.paint-calculator-container .quantity__input.paint-${availablePaints[i].slug}`
      );
      if (quantityInput) {
        quantityInput.value = counts[i];
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  const closeDrawer = (drawerWrapper) => {
    drawerWrapper.classList.remove('open');
    document.querySelector('#MainContent').classList.remove('drawer-open');
    document.querySelector('body').classList.remove('drawer-open');
  };

  function addFormData() {
    addBundleIncludedData();
    addBundleOptionsData();
    paints.forEach((paint, index) => {
      formData.items.push(createItemData(paint));
    });
  }

  function numberToWords(number) {
    const words = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    return words[number - 1];
  }

  function updateOptions() {
    options = Array.from(
      document.querySelectorAll('variant-selects select:not(.hidden), variant-selects fieldset'),
      (element) => {
        if (element.tagName === 'SELECT') {
          return element.value;
        }
        if (element.tagName === 'FIELDSET') {
          return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
        }
      }
    );
  }

  function updateMasterId(paints) {
    return paints.filter((variant) => {
      return !variant.options.map((option, index) => options[index] === option).includes(false);
    });
  }

  function updatePaints() {
    paints = JSON.parse(
      document
        .getElementById('calculate-paint')
        .dataset.paintData.replace(/'/g, '"')
        .replace(/\*/g, '"')
        .replace(/\$/g, ' ')
        .replace(/\^/g, "'")
    ).map(
      (data) =>
        new Paint(
          data.volume,
          data.price,
          data.slug,
          data.productId,
          data.id,
          data.options,
          data.numberOfCoats,
          data.paintCoverage,
          data.inputSlug,
          data.available
        )
    );
    updateOptions();
    if (options.length) {
      paints = updateMasterId(paints);
    }
    availablePaints = paints.filter((variant) => variant.available);
    updatePaintCalculator(Boolean(availablePaints.length));
    updateInputDisplays();
  }

  function updateInputDisplays() {
    document.querySelectorAll('.paint-calculator-container .variant-details').forEach((variantInput) => {
      if (variantInput.id.includes(paints[0].inputSlug)) {
        variantInput.classList.remove('hidden');
      } else {
        variantInput.classList.add('hidden');
      }
    });
  }

  function createItemData(item) {
    let data = {
      'product-id': item.productId,
      quantity: document.querySelector(`.paint-calculator-container .quantity__input.paint-${item.slug}`).value,
      id: item.variantId
    };
    if (document.querySelector('.color-palette-container')) {
      data.properties = {
        colour:
          document.querySelector('.color-palette-container .colour-input')?.value ||
          document.querySelector('.color-palette-container > .drawer-button').innerText
      };
    }

    return data;
  }

  function addBundleOptionsData() {
    if (document.querySelector('.bundle-options')) {
      document.querySelectorAll('.bundle-option.checked').forEach((option) => {
        formData.items.push({
          'product-id': option.dataset.id,
          quantity: 1,
          id: option.dataset.variantId
        });
      });
    }
  }

  function addBundleIncludedData() {
    if (document.querySelector('.bundle-includes')) {
      document.querySelectorAll('.bundle-includes li').forEach((option) => {
        formData.items.push({
          'product-id': option.dataset.id,
          quantity: 1,
          id: option.dataset.variantId
        });
      });
    }
  }

  function updateTotalCost(cost, first) {
    if (document.querySelector('.bundle-includes') && first) {
      document.querySelectorAll('.bundle-includes li').forEach((item) => {
        cost += Number(item.dataset.price);
      });
    }

    if (document.querySelector('.bundle-options') && first) {
      document.querySelectorAll('.bundle-options .bundle-option').forEach((option) => {
        if (option.classList.contains('checked')) {
          cost += Number(option.dataset.price);
        }
      });
    }

    totalCost.dataset.totalCost = cost;
    totalCost.innerText = Shopify.formatMoney(cost);
    document.querySelector('.variant-total-cost.price-excl > span').innerText = Shopify.formatMoney(
      Math.ceil(cost / Number(window.taxPercent))
    );
  }

  function updatePaintCalculator(bool) {
    if (bool) {
      document.querySelector('.paint-calculator-container .drawer-button').removeAttribute('disabled');
    } else {
      document.querySelector('.paint-calculator-container .drawer-button').setAttribute('disabled', 'true');
    }
  }

  const showErrorBanner = (parentNode, response) => {
    let errorMessage = response?.status === 422 ? window.errorMessage : window.outOfStockMessage;

    const bannerElement = document.createRange().createContextualFragment(`
      <div class="banner banner--error center" role="alert">
        ${errorMessage}
      </div>
    `).firstElementChild;
    parentNode.append(bannerElement);
    setTimeout(() => bannerElement.remove(), 5000);
  };
}

if ((Shopify.current_collection && Shopify.current_collection.id) || templateName === 'search') {
  document.addEventListener('modalOpened', paintCalculator);
} else {
  document.addEventListener('DOMContentLoaded', paintCalculator);
}
